import Icon from '../components/Icon.vue'

Icon.register({
  'briefcase-medical': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 128c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h80v-48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v48h80zM192 96v32h128v-32h-128zM352 344v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/briefcase-medical.js
// module id = 1120
// module chunks = 0